module.exports = __webpack_public_path__ + "img/mult_white.43aa5d00.svg";